import React, { Fragment } from "react";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Input,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import { confirmAlert } from "react-confirm-alert";
import confirmCss from "react-confirm-alert/src/react-confirm-alert.css";
import { searchDonorById } from "../../../utils/fetch";
import {
  ModalProps,
  serviceCaller,
  ServiceCallerProps,
  withLoginRedirect,
  withModals,
} from "../../composition";

import { firebaseConnect, isLoaded } from "react-redux-firebase";
import { connect } from "react-redux";

import get from "lodash.get";
import isEmpty from "lodash.isempty";
import isEqual from "lodash.isequal";
import isNil from "lodash.isnil";
import moment, { Moment } from "moment-timezone";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";

import {
  getImageMediaKey,
  getVideoMediaKey,
  nodeForPostType,
  postOnlySMS,
  getCharityLogoPostMedia,
  getMediaObject,
  getActiveMedium,
  validURLv2,
  postHasIncompleteMedia,
  isPostMediaUpdating,
} from "../../../utils/helpers";
import {
  IPost,
  PostType,
  PostStyle,
  editableStatus,
} from "../../../types/services/IPost";

import {
  clonePost,
  executePostExport,
  getSendingEmailAccount,
  getValidTime,
  getCurrentTime,
} from "../../../utils/fetch";
import { deletePostWithChildCleanup } from "../../../utils/postDelete";

import mediaPlaceholder from "../../../media/img/media.png";
import * as commonActions from "../../../utils/actions/common";
import {
  isCurrentUserCollaborator,
  isCurrentUserAdmin,
} from "../../../utils/roleCheck";
import { downloadFile } from "../../../utils/downloadBlobFile";
import { mergeSendingEmailDefault } from "../../../utils/sendingEmailDefault";
import { ScaleLoader } from "react-spinners";

import PostBasicInfo from "../postDetailBasicInfo";
import SegmentsSection from "../postDetailSegmentationSection";
import ExtraEmailSection from "../postDetailEmailSelectorSection";
import GiveButtonSection from "../postDetailGiveButtonSection";
import SharingHierarchySection from "../sharingHierarchySection";
import UploadMediaSection from "../postDetailImageSection";
import ScheduleSection from "../postDetailScheduleTimeSection";
import ChoiceInput from "../choiceInput";
import OnlySMSSection from "./onlySMSSection";
import IsEmbeddedSection from "./isEmbeddedSection";
import { IValidateResponse } from "../../../types/services/IValidateResponse";
import IClonePostResponse from "../../../types/services/IClonePostResponse";
import ISegment from "../../../types/services/ISegment";
import IEmailAccount from "../../../types/IEmailAccount";
import IsParentSection from "./ParentSection";
import SubCharitiesSection from "../postDetailSubCharitiesSection";
import { withRouter } from "../../../utils/withRouter";

interface Props extends ServiceCallerProps, ModalProps {
  currentPost?: {
    post: IPost;
    type: PostType;
  };
  pendingTwin?: IPost | null;
  userId: string;
  firebase: firebase.app.App;
  hideSelection: () => void;
  enableInformativePost: boolean;
  enableOnlySmsPost: boolean;
  enableTimeRestriction: boolean;
  enableMotivationCode: boolean;
  enableEmbeddedPost: boolean;
  enableSalutationMessage: boolean;
  enableUseCharityLogo: boolean;
  defaultMessageType?: "onlySms" | "onlyMms";
  showMmsVideoImage: boolean;
  smsPostNotifications: boolean;
  defaultInformativePost: boolean;
  disableGive: boolean;
  firebaseSegments: { [s: string]: ISegment };
  enableParentPost: boolean;
  firebaseSubCharities: { [s: string]: string };
  firebaseSelectedSubCharities?: Array<{ label: string; value: string }>;

  defaultSendingEmail?: IEmailAccount | null;
}

const MOTIVATION_CODE_LENGTH = 30;

/**
 * Realtime Database rules for `pendingPosts/{id}` enumerate allowed children; unknown keys fail `$other` validation.
 * Editing from a published post spreads `publishedPosts/{id}` data, which can include extra fields (e.g. `emailProvider`,
 * `isPaused`) or `clickCount` where rules expect `totalClicks`.
 */
const PENDING_POST_RTDB_KEYS: ReadonlyArray<string> = [
  "modifiedOn",
  "createdOn",
  "title",
  "content",
  "styledContent",
  "media",
  "status",
  "postType",
  "projectId",
  "authorId",
  "publisherId",
  "skipDraft",
  "scheduleTime",
  "segments",
  "donors",
  "origin",
  "excludeSegments",
  "excludeDonors",
  "segmentsCount",
  "targetedDonors",
  "disableNotifications",
  "notifications",
  "notificationsCount",
  "extraEmail",
  "validatePublishTime",
  "totalClicks",
  "shortUrl",
  "onlySmsUrl",
  "mobileContentUrl",
  "giveButtonUrl",
  "giveButtonLabel",
  "motivationCode",
  "donationIds",
  "cloned",
  "clonedBy",
  "clonedOn",
  "clonedFrom",
  "isEmbeddedPost",
  "isParentPost",
  "subCharities",
  "enableSalutationMessage",
  "enableUseCharityLogo",
  "metadata",
  "trackingSegmentId",
  "errorMessage",
];

function pickPendingPostPayloadForRtdb(post: IPost): IPost {
  const src = (post as unknown) as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  for (const key of PENDING_POST_RTDB_KEYS) {
    if (src[key] !== undefined) {
      out[key] = src[key];
    }
  }
  const clickCount = src.clickCount;
  if (clickCount !== undefined && out.totalClicks === undefined) {
    out.totalClicks = clickCount;
  }
  finalizePendingPostRtdbPayload(out);
  return (out as unknown) as IPost;
}

/**
 * Rules use `newData.isString()` on many optional fields — a present key with value `null` fails.
 * Several maps use `hasChildren()` — `{}` fails; omit the key when empty.
 */
function finalizePendingPostRtdbPayload(out: Record<string, unknown>): void {
  const omitIfEmptyObject = [
    "segments",
    "donors",
    "excludeSegments",
    "excludeDonors",
    "donationIds",
    "media",
    "subCharities",
    "metadata",
    "segmentsCount",
    "notificationsCount",
  ];
  for (const key of omitIfEmptyObject) {
    const v = out[key];
    if (
      v !== null &&
      v !== undefined &&
      typeof v === "object" &&
      !Array.isArray(v) &&
      Object.keys(v as object).length === 0
    ) {
      delete out[key];
    }
  }
  for (const key of Object.keys(out)) {
    if (out[key] === null) {
      delete out[key];
    }
  }
}

interface State {
  postId?: string;
  isNew: boolean;
  busyLoading: "draft" | "publish" | "delete" | "export" | "clone" | null;
  recipientsLoading: boolean;
  extrasMenuOpen: boolean;
  postDataLoaded: boolean;
  postType: PostStyle;
  isEmbeddedPost: boolean;
  isParentPost: boolean;
  enableSalutationMessage: boolean;
  enableUseCharityLogo: boolean;

  title: string;
  content: string;
  styledContent: string;
  basicErrors: Array<string>;
  showGiveButton: boolean;
  extraEmail?: IEmailAccount;
  motivationCode?: string;

  giveButtonUrl?: string;
  giveButtonLabel?: string;

  notifications: {
    sms: boolean;
    push: boolean;
    email: boolean;
  };

  scheduleDate?: Moment;
  validateTime: boolean;
  timeError: boolean;
  timeErrorValue: string;

  mediaKey?: string;
  mediaPreview?: string;
  imageUrl?: string;
  videoUrl?: string;
  isUploading: boolean;
  customThumbnailUpload: boolean;

  segmentsList: Array<{ label: string; value: string }>;
  excludeSegmentsList: Array<{ label: string; value: string }>;

  thanksDonationIds: Array<string>;
  thanksDonorSegments?: Array<{ label: string; value: string }>;

  subCharitiesList: Array<{ label: string; value: string }>;

  errors: any;

  isMobileToolbar: boolean;

  sendingEmailFromRedis: IEmailAccount | null;
}

class PostDetail extends React.PureComponent<Props, State> {
  private incompleteMediaDialogShown = false;

  private extrasToolbarMq: MediaQueryList | null = null;

  private readonly onExtrasToolbarMqChange = (): void => {
    if (this.extrasToolbarMq) {
      this.setState({
        isMobileToolbar: this.extrasToolbarMq.matches,
        extrasMenuOpen: false,
      });
    }
  };

  constructor(props: Props) {
    super(props);
    this.state = this.createBlankPostState(props);
  }

  createBlankPostState = (props: Props): State => ({
    postDataLoaded: false,
    extrasMenuOpen: false,
    isNew: true,
    busyLoading: null,
    recipientsLoading: false,
    title: "",
    content: "",
    styledContent: "",
    basicErrors: [],
    isUploading: false,
    customThumbnailUpload: false,
    mediaPreview: mediaPlaceholder,
    validateTime: props.enableTimeRestriction,
    timeError: false,
    timeErrorValue:
      "There is a conflict between the scheduled time and the publishing restriction. Please, change it",
    segmentsList: [],
    excludeSegmentsList: [],
    extraEmail: null,
    motivationCode: "",

    showGiveButton: !props.defaultInformativePost,
    giveButtonLabel: null,
    giveButtonUrl: null,

    notifications: {
      sms: true,
      email: true,
      push: false,
    },

    thanksDonationIds: [],
    thanksDonorSegments: null,

    postType: props.enableOnlySmsPost
      ? props.defaultMessageType === "onlySms"
        ? "onlySms"
        : "onlyMms"
      : "news",
    isEmbeddedPost: false,
    enableSalutationMessage: false,
    enableUseCharityLogo: false,
    errors: {},
    isParentPost: false,
    subCharitiesList: [],
    isMobileToolbar: false,
    sendingEmailFromRedis: null,
  });

  allocatePendingPostId = (): string => {
    return this.props.firebase
      .database()
      .ref()
      .child(this.props.currentCharity.id)
      .child("pendingPosts")
      .push().key as string;
  };

  initializeNewPost = () => {
    this.incompleteMediaDialogShown = false;
    const thanksDonorSegments = get(
      this.props.location,
      "state.thanksDonorSegments",
      null
    );
    const thanksDonationIds = get(
      this.props.location,
      "state.thanksDonationIds",
      []
    );
    this.setState(
      {
        ...this.createBlankPostState(this.props),
        postId: this.allocatePendingPostId(),
        isNew: true,
        postDataLoaded: true,
        thanksDonorSegments,
        thanksDonationIds,
      },
      () => {
        this.getThanksInfo();
        this.loadSendingEmailAccount();
      }
    );
  };

  initializeExistingPost = (postId: string) => {
    this.incompleteMediaDialogShown = false;
    this.setState(
      {
        ...this.createBlankPostState(this.props),
        postId,
        isNew: false,
        postDataLoaded: false,
      },
      () => {
        if (this.props.currentPost?.post) {
          this.fillPostData();
        }
      }
    );
  };

  syncRoutePost = (prevProps: Props) => {
    const prevRoutePostId = prevProps.params?.postId;
    const routePostId = this.props.params?.postId;
    if (prevRoutePostId === routePostId) {
      return;
    }
    if (!routePostId) {
      this.initializeNewPost();
      return;
    }
    if (routePostId !== this.state.postId) {
      this.initializeExistingPost(routePostId);
    }
  };

  getResolvedDefaultSendingEmail = (): IEmailAccount => {
    return mergeSendingEmailDefault(
      this.state.sendingEmailFromRedis,
      this.props.defaultSendingEmail
    );
  };

  loadSendingEmailAccount = (): void => {
    const adminUrl = get(this.props, "config.adminServiceUrl", "");
    const charityId = get(this.props, "currentCharity.id", "");
    const token = this.props.serviceAccessToken;
    if (!adminUrl || !charityId || !token) {
      return;
    }
    getSendingEmailAccount(charityId, adminUrl, token)
      .then(account => {
        this.setState({ sendingEmailFromRedis: account });
      })
      .catch(() => {
        this.setState({ sendingEmailFromRedis: null });
      });
  };

  getThanksInfo = async () => {
    let donationIds, donorsSegments;
    const paramDonorId = get(this.props.params, "donorId", null),
      paramDonationId = get(this.props.params, "donationId", null);
    if (
      paramDonorId &&
      paramDonationId &&
      isCurrentUserAdmin(this.props.currentCharity) &&
      get(this.props, "config.adminServiceUrl", false)
    ) {
      donationIds = [paramDonationId];
      const donor = await searchDonorById(
        this.props.config.adminServiceUrl,
        this.props.currentCharity.id,
        paramDonorId,
        this.props.serviceAccessToken
      );
      donorsSegments = [
        {
          label: donor.name + " - " + getActiveMedium(donor),
          value: "D" + paramDonorId,
        },
      ];
    } else {
      donationIds = get(this.props.location, "state.thanksDonationIds", []);
      donorsSegments = get(
        this.props.location,
        "state.thanksDonorSegments",
        null
      );
    }

    this.setState({
      thanksDonationIds: donationIds,
      thanksDonorSegments: donorsSegments,
    });
  };

  componentDidMount() {
    if (window) {
      window.scrollTo(0, 0);
    }
    if (typeof window !== "undefined" && window.matchMedia) {
      this.extrasToolbarMq = window.matchMedia("(max-width: 767px)");
      this.setState({ isMobileToolbar: this.extrasToolbarMq.matches });
      this.extrasToolbarMq.addEventListener(
        "change",
        this.onExtrasToolbarMqChange
      );
    }
    this.props.hideSelection();
    this.setPostId();
    if (this.props.currentPost && this.props.currentPost.post) {
      this.fillPostData();
    }
    this.getThanksInfo();
    this.loadSendingEmailAccount();
  }

  componentWillUnmount() {
    if (this.extrasToolbarMq) {
      this.extrasToolbarMq.removeEventListener(
        "change",
        this.onExtrasToolbarMqChange
      );
    }
  }

  async componentDidUpdate(prevProps: Props) {
    this.syncRoutePost(prevProps);

    const prevThanksSegments = get(
      prevProps.location,
      "state.thanksDonorSegments"
    );
    const nextThanksSegments = get(
      this.props.location,
      "state.thanksDonorSegments"
    );
    const prevThanksDonations = get(
      prevProps.location,
      "state.thanksDonationIds"
    );
    const nextThanksDonations = get(
      this.props.location,
      "state.thanksDonationIds"
    );
    if (
      !isEqual(prevThanksSegments, nextThanksSegments) ||
      !isEqual(prevThanksDonations, nextThanksDonations)
    ) {
      this.getThanksInfo();
    }

    if (
      prevProps.currentCharity &&
      prevProps.currentCharity.id !== this.props.currentCharity.id &&
      prevProps.currentCharity.id !== ""
    ) {
      this.props.navigate("/contacts");
    }

    if (
      !isEqual(prevProps.currentCharity.id, this.props.currentCharity.id) &&
      this.props.currentCharity.id &&
      !this.state.postId
    ) {
      this.setPostId();
    }
    if (
      !isEqual(this.props.currentPost, prevProps.currentPost) &&
      this.props.currentPost?.post
    ) {
      if (!this.state.postDataLoaded) {
        this.fillPostData();
      }
    }
    if (prevProps.enableTimeRestriction !== this.props.enableTimeRestriction) {
      this.setState({
        validateTime: this.props.enableTimeRestriction,
        timeError: false,
      });
    }
    if (
      prevProps.defaultInformativePost !== this.props.defaultInformativePost ||
      prevProps.enableInformativePost !== this.props.enableInformativePost
    ) {
      this.setState({
        showGiveButton: !this.props.defaultInformativePost,
      });
    }

    const enableOnlySmsJustLoaded =
      this.props.enableOnlySmsPost && !prevProps.enableOnlySmsPost;
    const charityConfigJustLoaded =
      !!this.props.currentCharity.id && !prevProps.currentCharity.id;
    if (
      this.state.isNew &&
      !this.props.params?.postId &&
      this.props.enableOnlySmsPost &&
      !postOnlySMS(this.state.postType) &&
      (enableOnlySmsJustLoaded || charityConfigJustLoaded)
    ) {
      this.setState({
        postType:
          this.props.defaultMessageType === "onlySms" ? "onlySms" : "onlyMms",
      });
    }

    if (
      !isEqual(prevProps.currentCharity, this.props.currentCharity) ||
      !isEqual(
        get(this.props, "config.adminServiceUrl"),
        get(prevProps, "config.adminServiceUrl")
      )
    ) {
      this.getThanksInfo();
    }
    if (
      prevProps.currentCharity.id !== this.props.currentCharity.id ||
      !isEqual(prevProps.serviceAccessToken, this.props.serviceAccessToken) ||
      get(prevProps, "config.adminServiceUrl") !==
        get(this.props, "config.adminServiceUrl")
    ) {
      this.loadSendingEmailAccount();
    }
  }

  stopLoading = () => {
    this.setState({
      busyLoading: null,
    });
  };

  hasEditStatus = (): boolean => {
    return !this.props.currentPost || this.hasAvailableStatus();
  };

  hasAvailableStatus = (): boolean => {
    const status = get(this.props.currentPost, "post.status", "");
    return editableStatus.includes(status);
  };

  showGiveButtonChanged = event => {
    this.setState({
      showGiveButton: event.target.checked,
    });
  };

  updateGiveButtonInfo = (
    giveButtonUrl: string,
    giveButtonLabel: string,
    giveButtonInfoError?: string
  ) => {
    this.setState(state => {
      const errors = state.errors;
      if (giveButtonInfoError === null) delete errors["giveButton"];
      else errors["giveButton"] = giveButtonInfoError;
      return {
        giveButtonUrl,
        giveButtonLabel,
        errors,
      };
    });
  };

  calculateNewPostStatus = (isDraft: boolean, isNew: boolean) => {
    if (!isNew && isDraft) {
      return "draft";
    } else if (isDraft && !this.state.imageUrl && !this.state.videoUrl) {
      return "draft";
    } else if (this.state.imageUrl || this.state.videoUrl) {
      return "processing";
    } else if (
      this.state.scheduleDate &&
      this.state.scheduleDate.unix() * 1000 > Date.now()
    ) {
      return isNew ? "processing" : "ready";
    } else {
      return "ready";
    }
  };

  deletePost = () => {
    if (window.confirm("Are you sure you want to delete this ViewSpark?")) {
      this.setState(
        {
          busyLoading: "delete",
          extrasMenuOpen: false,
        },
        () => {
          deletePostWithChildCleanup(
            this.props.currentCharity.id,
            this.props.currentPost.type,
            this.state.postId,
            this.props.config.adminServiceUrl,
            this.props.serviceAccessToken
          ).then(
            () => {
              this.props.navigate("/viewsparks");
            },
            error => {
              console.error("Error deleting post", error);
              this.stopLoading();
            }
          );
        }
      );
    }
  };

  getCurrentPostPostType = (): PostStyle => {
    if (["news", "informative"].includes(this.state.postType)) {
      return this.state.showGiveButton ? "news" : "informative";
    }

    return this.state.postType;
  };

  updateIsEmbeddedPost = event => {
    this.setState({
      isEmbeddedPost: event.target.checked,
      postType: this.getCurrentPostPostType(),
    });
  };

  updateIsParentPost = event => {
    this.setState({
      isParentPost: event.target.checked,
      postType: this.getCurrentPostPostType(),
    });
  };

  updateEnableSalutationMessage = event => {
    this.setState({
      enableSalutationMessage: event.target.checked,
    });
  };

  updateEnableUseCharityLogo = event => {
    if (this.isRemoteMediaUpdating()) {
      return;
    }
    this.setState({
      enableUseCharityLogo: event.target.checked,
    });
  };

  updateMessageType = (value: string) => {
    this.setState({
      postType: value === "onlySms" ? "onlySms" : "onlyMms",
      isEmbeddedPost: false,
    });
  };

  getNewPost = async (isDraft: boolean): Promise<IPost> => {
    let currentTime = await getCurrentTime(
      this.props.config.adminServiceUrl,
      this.props.currentCharity.id,
      this.props.serviceAccessToken
    );

    const { postType, giveButtonLabel, giveButtonUrl } = this.state;
    const donationIds: { [key: string]: boolean } = {};
    this.state.thanksDonationIds.forEach(
      donationId => (donationIds[donationId] = true)
    );

    let newPost: IPost = {
      ...(this.props.currentPost ? this.props.currentPost.post : {}),
      id: this.state.postId,
      title: this.getBasicInfoValue(this.state.title),
      content: this.getBasicInfoValue(this.state.content),
      styledContent: this.state.styledContent,
      postType: this.getCurrentPostPostType(),
      notifications: this.state.notifications,
      status: this.calculateNewPostStatus(isDraft, this.state.isNew),
      scheduleTime: this.state.scheduleDate
        ? this.state.scheduleDate.unix() * 1000
        : currentTime.time,
      skipDraft: !isDraft,
      donors: {},
      segments: {},
      excludeSegments: {},
      excludeDonors: {},
      extraEmail: null,
      motivationCode: null,
      giveButtonLabel: giveButtonLabel,
      giveButtonUrl: giveButtonUrl,
      isEmbeddedPost: this.state.isEmbeddedPost,
      enableSalutationMessage: this.state.enableSalutationMessage,
      enableUseCharityLogo: this.state.enableUseCharityLogo,
      donationIds,
      isParentPost: this.state.isParentPost,
      subCharities: {},
    };

    return newPost;
  };

  validateScheduleTime = async (newPost: IPost): Promise<IValidateResponse> => {
    let timeValid = await getValidTime(
      this.props.config.adminServiceUrl,
      this.props.currentCharity.id,
      this.props.serviceAccessToken,
      newPost.scheduleTime
    );

    if (timeValid.isValid)
      return { isOk: true, isTimeRestricted: false } as IValidateResponse;

    if (this.state.scheduleDate) {
      this.setState({
        timeError: true,
        busyLoading: null,
      });
      return { isOk: false } as IValidateResponse;
    } else {
      newPost.scheduleTime = timeValid.nextPublishTime;
      return {
        isOk: true,
        isTimeRestricted: true,
        isToday: !timeValid.isNextDay,
      } as IValidateResponse;
    }
  };

  checkErrors = async (): Promise<boolean> => {
    console.info("this.state.errors -> ", this.state.errors);
    if (!isEmpty(this.state.errors)) {
      alert("There is a problem with the post fields.");
      this.stopLoading();
      return false;
    } else {
      return true;
    }
  };
  validateGiveButtonUrl = async (newPost: IPost): Promise<boolean> => {
    if (newPost.giveButtonUrl) {
      if (validURLv2(newPost.giveButtonUrl)) {
        return true;
      }

      alert("Invalid Give Button url format");
      this.stopLoading();
      return false;
    }

    return true;
  };
  getPostRef = () => {
    return this.props.firebase
      .database()
      .ref()
      .child(this.props.currentCharity.id)
      .child("pendingPosts")
      .child(this.state.postId);
  };

  createEditPost = async (isDraft: boolean) => {
    this.setState({
      busyLoading: isDraft ? "draft" : "publish",
    });

    const { currentPost } = this.props;

    /** Same meaning as `getNewPost`'s `skipDraft: !isDraft` before RTDB normalization in `savePost`. */
    const requestedSkipDraft = !isDraft;

    let newPost: IPost = await this.getNewPost(isDraft);

    newPost.enableSalutationMessage = this.state.enableSalutationMessage;
    newPost.enableUseCharityLogo = this.state.enableUseCharityLogo;

    const oldPostSkipDraft = !this.state.isNew && requestedSkipDraft;

    if (oldPostSkipDraft && !newPost.publisherId) {
      newPost.publisherId = this.props.userId;
    } else if (this.state.isNew && !isDraft) {
      newPost.publisherId = this.props.userId;
    }

    if (
      oldPostSkipDraft &&
      currentPost.post.status === "draft" &&
      !currentPost.post.scheduleTime
    ) {
      newPost.scheduleTime = Date.now();
    }

    if (!this.state.isNew) {
      newPost.notificationsCount = get(
        currentPost,
        "post.notificationsCount",
        null
      );
      newPost.segmentsCount = get(currentPost, "post.segmentsCount", null);
      newPost.targetedDonors = get(currentPost, "post.targetedDonors", null);
    }

    if (this.state.isNew) {
      newPost.origin = "Web";
    } else {
      newPost.origin = get(currentPost, "post.origin", null);
    }

    if (!newPost.media) {
      newPost.media = {};
    }
    if (!newPost.createdOn) {
      newPost.createdOn = Date.now();
    } else {
      newPost.modifiedOn = Date.now();
    }
    if (!newPost.authorId) {
      newPost.authorId = firebase.auth().currentUser.uid;
    }

    newPost.validatePublishTime = this.state.validateTime;

    if (this.state.extraEmail) {
      newPost.extraEmail = this.state.extraEmail;
    }

    if (this.state.motivationCode !== "") {
      newPost.motivationCode = this.state.motivationCode;
    }

    const videoKeyExisting =
      currentPost?.post?.media && getVideoMediaKey(currentPost.post.media);
    const existingVideoUrlFromPost =
      videoKeyExisting && currentPost.post.media[videoKeyExisting]
        ? currentPost.post.media[videoKeyExisting].mediaUrl
        : null;
    const effectiveVideoUrl =
      this.state.videoUrl || existingVideoUrlFromPost || null;
    const resolvedMediaKey = this.state.mediaKey || videoKeyExisting || null;

    const previewMediaKey = resolvedMediaKey
      ? `${resolvedMediaKey}${effectiveVideoUrl ? "__preview" : ""}`
      : null;
    const existingPreviewMedia =
      previewMediaKey && currentPost?.post?.media
        ? currentPost.post.media[previewMediaKey]
        : null;
    const existingVideoMedia =
      videoKeyExisting && currentPost?.post?.media
        ? currentPost.post.media[videoKeyExisting]
        : null;

    if (this.state.imageUrl && resolvedMediaKey) {
      newPost.media = {};
      const previewObj = getMediaObject(
        "image",
        this.state.imageUrl,
        existingPreviewMedia
      );
      if (this.state.customThumbnailUpload) {
        previewObj.customThumbnail = true;
      } else if (
        existingPreviewMedia?.mediaUrl === this.state.imageUrl &&
        existingPreviewMedia.customThumbnail
      ) {
        previewObj.customThumbnail = true;
      }
      newPost.media[previewMediaKey] = previewObj;
    }

    if (effectiveVideoUrl && resolvedMediaKey) {
      const videoObj = getMediaObject(
        "video",
        effectiveVideoUrl,
        existingVideoMedia
      );
      if (this.state.imageUrl) {
        videoObj.thumbnail = this.state.imageUrl;
      } else if (existingVideoMedia?.thumbnail) {
        videoObj.thumbnail = existingVideoMedia.thumbnail;
      }
      newPost.media[`${resolvedMediaKey}`] = videoObj;
    }

    if (this.state.isParentPost && !isEmpty(this.props.firebaseSubCharities)) {
      if (!isEmpty(this.state.subCharitiesList)) {
        this.state.subCharitiesList.forEach(element => {
          newPost.subCharities[element.value] = true;
        });
      } else {
        Object.keys(this.props.firebaseSubCharities).forEach(key => {
          newPost.subCharities[key] = true;
        });
      }
    }

    if (this.state.enableUseCharityLogo) {
      newPost.media = {};
      const mainImageRef = this.getPostRef()
        .child("media")
        .push();
      newPost.media[mainImageRef.key] = await getCharityLogoPostMedia(
        this.props.currentCharity?.id
      );

      newPost.status = isDraft ? "draft" : "ready";
    }

    this.state.segmentsList.forEach(element => {
      element.value.charAt(0) === "D"
        ? (newPost.donors[element.value.slice(1)] = true)
        : (newPost.segments[element.value.slice(1)] = true);
    });
    this.state.excludeSegmentsList.forEach(element => {
      element.value.charAt(0) === "D"
        ? (newPost.excludeDonors[element.value.slice(1)] = true)
        : (newPost.excludeSegments[element.value.slice(1)] = true);
    });

    let isOkMessage = {} as IValidateResponse;
    if (
      !this.state.isEmbeddedPost &&
      this.state.validateTime &&
      this.canEditPublishing() &&
      !isDraft
    ) {
      isOkMessage = await this.validateScheduleTime(newPost);
      if (!isOkMessage.isOk) {
        return;
      }
    }

    const postWithGiveButtonURLOK = await this.validateGiveButtonUrl(newPost);
    const postReady = await this.checkErrors();

    if (
      postReady &&
      postWithGiveButtonURLOK &&
      !isDraft &&
      (this.state.isNew || this.props.currentPost.type === "pending")
    ) {
      return confirmAlert({
        customUI: ({ onClose }) => {
          return this.getConfirmMessage(onClose, newPost, isOkMessage);
        },
        onClickOutside: () => {
          this.stopLoading();
        },
      });
    }

    if (postReady && postWithGiveButtonURLOK) {
      delete newPost.id;
      return this.savePost(newPost);
    }
  };

  savePost = (newPostParam: IPost): void => {
    let newPost: IPost =
      newPostParam.isEmbeddedPost || newPostParam.isParentPost
        ? this.cleanPost(newPostParam, newPostParam.isParentPost)
        : newPostParam;

    const postRef = this.props.firebase
      .database()
      .ref()
      .child(this.props.currentCharity.id)
      .child("pendingPosts")
      .child(this.state.postId);

    postRef
      .once("value")
      .then(snapshot => {
        const pendingExists = snapshot.exists();
        const toSave: IPost = {
          ...pickPendingPostPayloadForRtdb(newPost),
        };
        // First client write when `pendingPosts/{id}` is empty: rules require `status == "uploading"`.
        // `skipDraft` stays whatever `getNewPost` set (`!isDraft`); `mediaStatusRefresh` uses it for ready vs draft.
        if (!pendingExists) {
          toSave.status = "uploading";
        }
        if (
          pendingExists &&
          this.props.currentCharity.role === "COLLABORATOR"
        ) {
          const edits: Record<string, unknown> = {};
          for (const field of [
            "title",
            "content",
            "styledContent",
            "media",
            "modifiedOn",
            "segments",
            "donors",
            "excludeSegments",
            "excludeDonors",
          ]) {
            edits[field] = toSave[field] ?? null;
          }
          return postRef.update(edits);
        }
        return postRef.set(toSave);
      })
      .then(
        () => {
          this.props.navigate("/viewsparks");
        },
        error => {
          console.error(error);
          this.stopLoading();
        }
      );
  };

  cleanPost = (post: IPost, keepNotifications: Boolean): IPost => {
    return {
      ...post,
      postType: this.getCurrentPostPostType(),
      segments: {},
      donors: {},
      excludeSegments: {},
      excludeDonors: {},
      extraEmail: null,
      motivationCode: null,
      notifications: keepNotifications
        ? post.notifications
        : {
            sms: false,
            email: false,
            push: false,
          },
      scheduleTime: Date.now(),
    };
  };

  setPostId = () => {
    if (this.props.currentCharity.id && !this.state.postId) {
      this.setState({
        postId: !this.props.params.postId
          ? this.props.firebase
              .database()
              .ref()
              .child(this.props.currentCharity.id)
              .child("pendingPosts")
              .push().key
          : this.props.params.postId,
      });
    }
  };

  toggleExtrasMenu = () => {
    this.setState(state => ({ extrasMenuOpen: !state.extrasMenuOpen }));
  };

  shouldShowExtrasMenu = (): boolean => {
    return (
      isCurrentUserCollaborator(this.props.currentCharity) &&
      this.props.currentPost != null &&
      !this.state.isNew &&
      this.hasAvailableStatus()
    );
  };

  renderExtrasDropdown = (direction: "up" | "down") => {
    return (
      <Dropdown
        direction={direction}
        isOpen={this.state.extrasMenuOpen}
        toggle={this.toggleExtrasMenu}
      >
        <DropdownToggle
          color="link"
          className={s.toolbarExtras}
          disabled={
            this.state.busyLoading !== null || this.isRemoteMediaUpdating()
          }
          aria-label="More actions"
        >
          <i className="fa fa-ellipsis-v" />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem
            onClick={() => this.deletePost()}
            disabled={this.disableToDelete()}
          >
            {this.showSpinner("delete") ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              "Delete"
            )}
          </DropdownItem>
          <DropdownItem
            onClick={() => this.exportPost()}
            disabled={
              this.state.busyLoading !== null ||
              !this.hasEditStatus() ||
              this.isRemoteMediaUpdating()
            }
          >
            {this.showSpinner("export") ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              "Export"
            )}
          </DropdownItem>
          <DropdownItem
            onClick={() => this.clonePostFromEditor()}
            disabled={
              this.state.busyLoading !== null ||
              !this.hasEditStatus() ||
              this.isRemoteMediaUpdating()
            }
          >
            {this.showSpinner("clone") ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              "Clone"
            )}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  clonePostFromEditor = () => {
    if (
      !this.props.currentPost ||
      !window.confirm("Are you sure you want to clone this ViewSpark?")
    ) {
      return;
    }
    this.setState(
      {
        busyLoading: "clone",
        extrasMenuOpen: false,
      },
      () => {
        clonePost(
          this.props.currentCharity.id,
          this.props.currentPost.type,
          this.state.postId,
          this.props.config.adminServiceUrl,
          this.props.serviceAccessToken
        ).then(
          (clonePostResponse: IClonePostResponse) => {
            window.alert(clonePostResponse.message);
            this.props.navigate(
              `/viewsparks/pending/${clonePostResponse.postId}`
            );
            this.stopLoading();
          },
          error => {
            console.error("Error cloning post", error);
            this.stopLoading();
          }
        );
      }
    );
  };

  exportPost = () => {
    this.setState(
      {
        busyLoading: "export",
        extrasMenuOpen: false,
      },
      () => {
        executePostExport(
          this.props.config.adminServiceUrl,
          this.props.currentCharity.id,
          this.state.postId,
          this.props.serviceAccessToken,
          this.props.currentPost.type.toUpperCase()
        ).then(blob => {
          downloadFile(blob, `Post_${this.props.currentPost.post.title}.csv`);
          this.setState({
            busyLoading: null,
          });
        });
      }
    );
  };

  postWithDefaultMedia = (): boolean => {
    let defaultMedia = !this.state.imageUrl;
    const { currentPost } = this.props;

    if (currentPost) {
      const postMedia = currentPost.post.media;
      const keyPostMedia = getImageMediaKey(postMedia);
      defaultMedia = keyPostMedia
        ? !Boolean(this.state.imageUrl) && postMedia[keyPostMedia].defaultMedia
        : true;
    }

    return defaultMedia;
  };

  fillPostData = () => {
    if (!this.props.currentPost?.post) {
      return;
    }
    const { post } = this.props.currentPost;
    this.setState(
      {
        scheduleDate: moment(post.scheduleTime),
        isNew: false,
        postDataLoaded: true,
        validateTime: !!get(post, "validatePublishTime"),
        showGiveButton: post.postType == "news",
        postType: post.postType,
        giveButtonLabel: post.giveButtonLabel,
        giveButtonUrl: post.giveButtonUrl,
        thanksDonationIds: post.donationIds
          ? Object.keys(post.donationIds)
          : [],
        extraEmail: post.extraEmail,
        motivationCode: post.motivationCode ? post.motivationCode : "",
        isEmbeddedPost: post.isEmbeddedPost ? post.isEmbeddedPost : false,
        isParentPost: post.isParentPost ? post.isParentPost : false,
        enableSalutationMessage: post.enableSalutationMessage
          ? post.enableSalutationMessage
          : false,
        enableUseCharityLogo: post.enableUseCharityLogo
          ? post.enableUseCharityLogo
          : false,
      },
      () => {
        if (
          !this.incompleteMediaDialogShown &&
          post.status === "error" &&
          postHasIncompleteMedia(post)
        ) {
          this.incompleteMediaDialogShown = true;
          confirmAlert({
            customUI: ({ onClose }) => this.getIncompleteMediaMessage(onClose),
          });
        }
      }
    );
  };

  loadDonorsID = (donorList: { [key: string]: boolean }): Array<string> => {
    let ids = [];
    for (let key in donorList) {
      ids.push(key);
    }
    return ids;
  };

  canDraft = () => {
    const { title, content } = this.state;
    const contentLength = content ? content.length : 0;
    const titleLength = title ? title.length : 0;
    const defaultMedia = this.postWithDefaultMedia();
    return (
      !this.isUploading() &&
      (titleLength > 0 || contentLength > 0 || !defaultMedia)
    );
  };

  canSave = () => {
    const { title, content } = this.state;
    const contentLength = content ? content.length : 0;
    const titleLength = title ? title.length : 0;

    return (
      !this.isUploading() &&
      (this.props.currentPost ||
        this.state.imageUrl ||
        this.state.enableUseCharityLogo) &&
      titleLength > 0 &&
      contentLength > 0
    );
  };

  canEditPublishing = (): boolean => {
    return (
      this.state.isNew ||
      (this.props.currentPost && this.props.currentPost.type === "pending")
    );
  };

  isRemoteMediaUpdating = (): boolean => {
    const current = this.props.currentPost && this.props.currentPost.post;
    if (isPostMediaUpdating(current)) {
      return true;
    }
    return Boolean(
      this.props.currentPost &&
        this.props.currentPost.type === "published" &&
        isPostMediaUpdating(this.props.pendingTwin)
    );
  };

  canEditDeliveredPublishedCopy = (): boolean => {
    return Boolean(
      this.props.currentPost &&
        this.props.currentPost.type === "published" &&
        this.props.currentPost.post &&
        this.props.currentPost.post.status === "delivered" &&
        !this.isRemoteMediaUpdating()
    );
  };

  isMediaUpdating = (): boolean => {
    return this.state.isUploading || this.isRemoteMediaUpdating();
  };

  getBasicInfoValue = (value): string => {
    return isEmpty(value) || value == undefined ? null : value;
  };

  updateBasicInfo = fields => {
    this.setState({ ...fields });
  };

  updateSegments = (segments, excluded) => {
    this.setState({
      postDataLoaded: true,
      excludeSegmentsList: excluded,
      segmentsList: segments,
    });
  };

  updateRecipientsLoading = (recipientsLoading: boolean) => {
    this.setState({ recipientsLoading });
  };

  updateSubCharities = subCharities => {
    this.setState({
      postDataLoaded: true,
      subCharitiesList: subCharities,
    });
  };

  updateExtraEmail = email => {
    this.setState({ extraEmail: email });
  };

  updateMotivationCode = motCodeEvent => {
    let motivationCode = motCodeEvent.target.value.replace(" ", "");
    this.setState(state => {
      const errors = state.errors;
      if (motivationCode.length > MOTIVATION_CODE_LENGTH)
        errors["motivationCode"] = "Motivation Code too long";
      else delete errors["motivationCode"];
      return { motivationCode, errors };
    });
  };

  updateSharingHierarchy = options => {
    this.setState({
      notifications: {
        sms: options.sms,
        email: options.email,
        push: false,
      },
    });
  };

  startUploadingMedia = (mediaKey: string, mediaPreview: string) => {
    this.setState({
      imageUrl: null,
      videoUrl: null,
      isUploading: true,
      mediaKey,
      mediaPreview,
      customThumbnailUpload: false,
      enableUseCharityLogo: false,
    });
  };

  startPreviewThumbnailUpload = (mediaKey: string, mediaPreview: string) => {
    this.setState({
      imageUrl: null,
      isUploading: true,
      mediaKey,
      mediaPreview,
      customThumbnailUpload: true,
    });
  };

  updateCustomThumbnailUpload = (customThumbnailUpload: boolean) => {
    this.setState({ customThumbnailUpload });
  };

  updateProgress = (isUploading: boolean): void => {
    this.setState({ isUploading });
  };
  updateImageMedia = (imageUrl: string, isUploading: boolean) => {
    this.setState({ imageUrl, isUploading });
  };
  updateVideoMedia = (videoUrl: string, isUploading: boolean) => {
    this.setState({ videoUrl, isUploading });
  };

  isUploading = () => {
    return this.state.isUploading;
  };

  updateScheduleDateHandler = (scheduleDate: Moment) => {
    this.setState({
      scheduleDate,
      timeError: false,
    });
  };

  updateScheduleCheckedHandler = (checked: boolean) => {
    this.setState({
      validateTime: checked,
      timeError: false,
    });
  };

  getIncompleteMediaMessage = (onClose: () => void) => {
    return (
      <div className={s.confirmModal}>
        <h2>Media not uploaded</h2>
        <p>
          Your media file didn&apos;t upload successfully. Please try uploading
          the file again, or upload a different file before publishing.
        </p>
        <div className={s.centered}>
          <button type="button" className={s.button} onClick={() => onClose()}>
            OK
          </button>
        </div>
      </div>
    );
  };

  // Try to move to a component and make it work with the alert library.

  getConfirmMessage = (
    onClose,
    newPost: IPost,
    isOkMessage: IValidateResponse
  ) => {
    const momentDate = moment.unix(newPost.scheduleTime / 1000);
    const shceduledDate = new Date(newPost.scheduleTime),
      nowDate = new Date(Date.now());
    const isToday =
      shceduledDate.getFullYear() == nowDate.getFullYear() &&
      shceduledDate.getMonth() == nowDate.getMonth() &&
      shceduledDate.getDate() == nowDate.getDate();

    let whenMessage;
    if (!isOkMessage.isTimeRestricted) {
      whenMessage =
        newPost.scheduleTime <= Date.now() || newPost.isEmbeddedPost ? (
          <span>
            <strong>Now</strong>
          </span>
        ) : isToday ? (
          <span>
            <strong>Today</strong> at{" "}
            <strong>{momentDate.format("h:mm a")}</strong>
          </span>
        ) : (
          <span>
            on <strong>{momentDate.format("MMMM Do YYYY")}</strong> at{" "}
            <strong>{momentDate.format("h:mm a")}</strong>
          </span>
        );
    } else {
      whenMessage = isOkMessage.isToday ? (
        <strong>today at 8 am PST</strong>
      ) : (
        <strong>tomorrow at 8 am PST</strong>
      );
    }

    if (newPost.isEmbeddedPost || newPost.isParentPost) {
      return (
        <div className={s.confirmModal}>
          <div className={s.confirmModalTop}>
            <h2>Publish ViewSpark</h2>
            {newPost.isEmbeddedPost && (
              <p>
                This ViewSpark is going to be published {whenMessage} to{" "}
                <strong>Embedded Page.</strong>
              </p>
            )}
            {newPost.isParentPost && (
              <p>
                This ViewSpark is going to be created as a draft in the selected{" "}
                <strong>Sub-accounts</strong>
              </p>
            )}
          </div>
          <div className={s.confirmModalFooter}>
            <p>Click Ok to continue.</p>
            <div className={s.centered}>
              <button
                className={s.button}
                onClick={() => {
                  this.stopLoading();
                  onClose();
                }}
              >
                Cancel
              </button>
              <button
                className={s.button}
                onClick={() => {
                  onClose();
                  delete newPost.id;
                  return this.savePost(newPost);
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      );
    }

    const extraEmail = this.state.extraEmail;
    const resolvedDefault = this.getResolvedDefaultSendingEmail();
    const extraEmailMessage =
      extraEmail === null || extraEmail === undefined ? (
        String(resolvedDefault.email || "").length > 0 ? (
          <strong>{resolvedDefault.email}</strong>
        ) : (
          <strong>default email address</strong>
        )
      ) : (
        <strong>
          {extraEmail.name} - {extraEmail.email}
        </strong>
      );

    let mediumMessage;
    let mobileMode =
      !this.props.showMmsVideoImage || this.state.postType == "onlySms"
        ? "SMS"
        : "MMS";

    if (this.state.notifications.email && this.state.notifications.sms) {
      mediumMessage = (
        <span>
          using <strong>{mobileMode}</strong> and <strong>Email</strong> (
          {extraEmailMessage})
        </span>
      );
    } else if (this.state.notifications.email) {
      mediumMessage = (
        <span>
          using <strong>only Email</strong> ({extraEmailMessage})
        </span>
      );
    } else if (this.state.notifications.sms) {
      mediumMessage = (
        <span>
          using <strong>only {mobileMode}</strong>
        </span>
      );
    }

    if (
      this.state.segmentsList.length === 0 &&
      this.state.excludeSegmentsList.length === 0
    ) {
      return (
        <div className={s.confirmModal}>
          <div className={s.confirmModalTop}>
            <h2>Publish ViewSpark</h2>
            <p>
              This ViewSpark is going to be published {whenMessage} to{" "}
              <strong>All Contacts</strong> {mediumMessage}.
            </p>
          </div>
          <div className={s.confirmModalFooter}>
            <p>Click Ok to continue.</p>
            <div className={s.centered}>
              <button
                className={s.button}
                onClick={() => {
                  this.stopLoading();
                  onClose();
                }}
              >
                Cancel
              </button>
              <button
                className={s.button}
                onClick={() => {
                  onClose();
                  delete newPost.id;
                  return this.savePost(newPost);
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      );
    }
    let segments = "";
    let totalSegments = 0;
    let donors = "";
    let totalDonors = 0;
    let excludedSegments = "";
    let totalExcludedSegments = 0;
    let excludedDonors = "";
    let totalExcludedDonors = 0;

    let segment = null as ISegment;

    this.state.segmentsList.forEach(element => {
      if (element.value.charAt(0) === "D") {
        donors += element.label + ", ";
        totalDonors++;
      } else {
        segment = this.props.firebaseSegments[element.value.slice(1)];
        segments += `${element.label}${
          segment.donorCount >= 0 ? `(${segment.donorCount})` : ""
        }, `;
        totalSegments++;
      }
    });
    this.state.excludeSegmentsList.forEach(element => {
      if (element.value.charAt(0) === "D") {
        excludedDonors += element.label + ", ";
        totalExcludedDonors++;
      } else {
        segment = this.props.firebaseSegments[element.value.slice(1)];
        excludedSegments += `${element.label}${
          segment.donorCount >= 0 ? `(${segment.donorCount})` : ""
        }, `;
        totalExcludedSegments++;
      }
    });
    segments = segments.substr(0, segments.length - 2);
    donors = donors.substr(0, donors.length - 2);
    excludedSegments = excludedSegments.substr(0, excludedSegments.length - 2);
    excludedDonors = excludedDonors.substr(0, excludedDonors.length - 2);

    return (
      <div className={s.confirmModal}>
        <div className={s.confirmModalTop}>
          <h2>Publish ViewSpark</h2>
          <p>
            This ViewSpark is going to be published {whenMessage}{" "}
            {mediumMessage} to:
          </p>
        </div>
        <div className={s.confirmModalScroll}>
          <ul>
            {totalSegments > 0 && (
              <li>
                <strong>{`Segments(${totalSegments}): `}</strong>
                <span>{`${segments}.`}</span>
              </li>
            )}
            {totalDonors > 0 && (
              <li>
                <strong>{`Contacts(${totalDonors}): `}</strong>
                <span>{`${donors}.`}</span>
              </li>
            )}
            {totalExcludedSegments > 0 && (
              <li>
                <strong>{`Excluded Segments(${totalExcludedSegments}): `}</strong>
                <span>{`${excludedSegments}.`}</span>
              </li>
            )}
            {totalExcludedDonors > 0 && (
              <li>
                <strong>{`Excluded Contacts(${totalExcludedDonors}): `}</strong>
                <span>{`${excludedDonors}.`}</span>
              </li>
            )}
          </ul>
        </div>
        <div className={s.confirmModalFooter}>
          <p>Click Ok to continue.</p>
          <div className={s.centered}>
            <button
              className={s.button}
              onClick={() => {
                this.stopLoading();
                onClose();
              }}
            >
              Cancel
            </button>
            <button
              className={s.button}
              onClick={() => {
                onClose();
                delete newPost.id;
                return this.savePost(newPost);
              }}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    );
  };

  disableToDelete = (): boolean => {
    return (
      this.state.busyLoading != null ||
      !this.hasEditStatus() ||
      this.isRemoteMediaUpdating()
    );
  };

  disableToDraft = (): boolean => {
    return (
      !this.canDraft() ||
      this.state.busyLoading !== null ||
      this.state.recipientsLoading ||
      !this.hasEditStatus() ||
      this.isRemoteMediaUpdating() ||
      this.state.basicErrors.length > 0 ||
      Object.keys(this.state.errors).length > 0
    );
  };

  disableToPublish = (): boolean => {
    return (
      this.props.currentCharity.role === "COLLABORATOR" ||
      !this.canSave() ||
      (this.postWithDefaultMedia() && !this.state.enableUseCharityLogo) ||
      this.state.busyLoading !== null ||
      this.state.recipientsLoading ||
      !this.hasEditStatus() ||
      this.isRemoteMediaUpdating() ||
      this.state.basicErrors.length > 0 ||
      Object.keys(this.state.errors).length > 0
    );
  };

  showSpinner = (status: string): boolean => {
    return this.state.busyLoading === status;
  };

  render() {
    const {
      currentPost,
      currentCharity,
      enableEmbeddedPost,
      enableParentPost,
    } = this.props;
    const { postType, busyLoading, isEmbeddedPost, isParentPost } = this.state;

    const isSmsOrMmsPost = postOnlySMS(postType);
    const enableInformativePost = this.props.enableInformativePost;
    const enableSalutationFeature = this.props.enableSalutationMessage;
    const enableSalutationMessage = this.state.enableSalutationMessage;
    const enableUseCharityLogoFeature = this.props.enableUseCharityLogo;
    const enableUseCharityLogo = this.state.enableUseCharityLogo;

    const showMessageTypeToggle =
      !isEmbeddedPost &&
      !isParentPost &&
      this.props.smsPostNotifications &&
      this.props.enableOnlySmsPost &&
      isSmsOrMmsPost;

    let numberOfCol = 0;
    if (!isEmbeddedPost) {
      numberOfCol++;
    }
    if (showMessageTypeToggle) {
      numberOfCol++;
    }
    if (!enableInformativePost && !showMessageTypeToggle) {
      numberOfCol++;
    }
    if (enableInformativePost && !isParentPost) {
      numberOfCol++;
    }
    if (!isEmbeddedPost && !isParentPost) {
      numberOfCol++;
    }
    numberOfCol = Math.max(numberOfCol, 1);

    const colSize = 12 / numberOfCol;
    let mediaPreview = this.state.mediaPreview;

    if (currentPost) {
      mediaPreview = getImageMediaKey(currentPost.post.media)
        ? currentPost.post.media[
            getImageMediaKey(this.props.currentPost.post.media)
          ].mediaUrl
        : "";
    }

    const existingVideoMediaKey =
      this.state.mediaKey ||
      (currentPost && currentPost.post.media
        ? getVideoMediaKey(currentPost.post.media)
        : null);

    const canEditable = this.canEditPublishing();
    const editorSessionKey =
      this.props.params.postId || this.state.postId || "new";

    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row>
            <Col md={{ size: 4, offset: 2 }} sm={12} className={s.titleCol}>
              <div className={s.titleRow}>
                <h2>
                  {this.props.params.postId
                    ? "Edit ViewSpark"
                    : "New ViewSpark"}
                </h2>
                {this.state.isMobileToolbar && this.shouldShowExtrasMenu() && (
                  <div className={s.titleExtras}>
                    {this.renderExtrasDropdown("down")}
                  </div>
                )}
              </div>
            </Col>
            <Col
              md={{
                size: 4,
                offset:
                  ((enableEmbeddedPost || enableParentPost) &&
                    !this.props.enableOnlySmsPost) ||
                  isEmbeddedPost ||
                  isParentPost
                    ? 2
                    : 0,
              }}
              sm={12}
            >
              <Row>
                {enableEmbeddedPost && canEditable && !isParentPost && (
                  <IsEmbeddedSection
                    enableEmbeddedPost={enableEmbeddedPost}
                    isEmbeddedPost={isEmbeddedPost}
                    updateIsEmbeddedPost={this.updateIsEmbeddedPost}
                    offSet={
                      isEmbeddedPost || !this.props.enableOnlySmsPost ? 12 : 0
                    }
                  />
                )}

                {enableParentPost && canEditable && !isEmbeddedPost && (
                  <IsParentSection
                    enableParentPost={enableParentPost}
                    isParentPost={isParentPost}
                    updateIsParentPost={this.updateIsParentPost}
                    offSet={
                      isParentPost || !this.props.enableOnlySmsPost ? 6 : 0
                    }
                  />
                )}
              </Row>
            </Col>
          </Row>

          {(currentPost || !this.props.params.postId) && (
            <Fragment>
              <Row>
                <UploadMediaSection
                  key={`media-${editorSessionKey}`}
                  updateVideoUrl={this.updateVideoMedia}
                  updateImageUrl={this.updateImageMedia}
                  startUploading={this.startUploadingMedia}
                  startPreviewThumbnailUpload={this.startPreviewThumbnailUpload}
                  updateCustomThumbnailUpload={this.updateCustomThumbnailUpload}
                  updateProgress={this.updateProgress}
                  currentPost={currentPost}
                  postTitle={this.getBasicInfoValue(this.state.title)}
                  mediaPreview={mediaPreview}
                  busyLoading={this.state.busyLoading}
                  mediaUpdating={this.isMediaUpdating()}
                  postId={this.state.postId}
                  enableUseCharityLogoFeature={enableUseCharityLogoFeature}
                  enableUseCharityLogo={enableUseCharityLogo}
                  updateEnableUseCharityLogo={this.updateEnableUseCharityLogo}
                  existingVideoMediaKey={existingVideoMediaKey}
                />
                <PostBasicInfo
                  key={`basic-${editorSessionKey}`}
                  onlySMS={postType}
                  currentPost={currentPost}
                  busyLoading={this.state.busyLoading}
                  updateBasicInfo={this.updateBasicInfo}
                  disabled={
                    !canEditable && !this.canEditDeliveredPublishedCopy()
                  }
                  thanksDonationIds={this.state.thanksDonationIds}
                  thanksDonorSegments={this.state.thanksDonorSegments}
                  enableSalutationFeature={
                    enableSalutationFeature && !isParentPost
                  }
                  updateEnableSalutationMessage={
                    this.updateEnableSalutationMessage
                  }
                  enableSalutationMessage={enableSalutationMessage}
                />
              </Row>
              <SegmentsSection
                key={`segments-${editorSessionKey}`}
                canEditPublishing={canEditable}
                busyLoading={this.state.busyLoading}
                updateSegments={this.updateSegments}
                updateRecipientsLoading={this.updateRecipientsLoading}
                disabled={!canEditable}
                thanksDonorSegments={this.state.thanksDonorSegments}
                isVisible={!(isEmbeddedPost || isParentPost)}
              />

              <SubCharitiesSection
                canEditPublishing={canEditable}
                busyLoading={this.state.busyLoading}
                updateSubcharities={this.updateSubCharities}
                disabled={!canEditable}
                firebaseSelectedSubCharities={
                  this.props.firebaseSelectedSubCharities
                }
                firebaseSubCharities={this.props.firebaseSubCharities}
                isVisible={isParentPost}
              />

              <ExtraEmailSection
                currentPost={currentPost}
                canEditPublishing={canEditable}
                busyLoading={this.state.busyLoading}
                updateEmailSelected={this.updateExtraEmail}
                isVisible={!(isEmbeddedPost || isParentPost)}
                redisSendingEmail={this.state.sendingEmailFromRedis}
                firebaseDefaultSendingEmail={this.props.defaultSendingEmail}
              />
              {this.props.enableMotivationCode &&
                !isEmbeddedPost &&
                !isParentPost && (
                  <Row>
                    <Col lg={12} xl={{ size: 8, offset: 2 }}>
                      <FormGroup>
                        <label
                          className={s.titleLabel}
                          htmlFor="motivationCode"
                        >
                          Motivation Code
                          <span
                            className={
                              this.state.motivationCode.length >
                              MOTIVATION_CODE_LENGTH
                                ? s.invalidContentLength
                                : s.contentLength
                            }
                          >
                            {this.state.motivationCode.length} /{" "}
                            {MOTIVATION_CODE_LENGTH}
                          </span>
                        </label>
                        <Input
                          type="text"
                          name="motivationCode"
                          id="motivationCode"
                          placeholder="No Motivation Code"
                          value={this.state.motivationCode}
                          onChange={this.updateMotivationCode}
                          disabled={
                            !canEditable ||
                            busyLoading !== null ||
                            !isCurrentUserCollaborator(currentCharity)
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}

              <GiveButtonSection
                canUseGiveButtonInfo={this.state.showGiveButton}
                currentPost={currentPost}
                canEditPublishing={canEditable}
                busyLoading={this.state.busyLoading}
                updateGiveButtonInfo={this.updateGiveButtonInfo}
                isVisible={!isParentPost}
              />

              <Row className={s.extraTopMargin}>
                <Col lg={12} xl={{ size: 8, offset: 2 }}>
                  <Row className={isEmbeddedPost ? s.planningContainer : ""}>
                    <SharingHierarchySection
                      key={`sharing-${editorSessionKey}`}
                      currentPost={currentPost}
                      canEditPublishing={canEditable}
                      busyLoading={this.state.busyLoading}
                      isNew={this.state.isNew}
                      colSize={colSize}
                      updateSharingHierarchy={this.updateSharingHierarchy}
                      isVisible={!isEmbeddedPost}
                    />

                    {showMessageTypeToggle && (
                      <OnlySMSSection
                        colSize={colSize}
                        disabled={!canEditable}
                        postType={postType}
                        onChange={this.updateMessageType}
                      />
                    )}

                    {!enableInformativePost && !showMessageTypeToggle && (
                      <Col sm={!isEmbeddedPost ? colSize : colSize * 2} />
                    )}

                    {enableInformativePost && !isParentPost && (
                      <ChoiceInput
                        colSize={colSize}
                        title={"Display Give button"}
                        checked={this.state.showGiveButton}
                        id={
                          "giveButton" +
                          (this.state.showGiveButton
                            ? "_checked"
                            : "_unchecked")
                        }
                        onChangeHandler={this.showGiveButtonChanged}
                        isDisabled={
                          !canEditable ||
                          !isCurrentUserCollaborator(
                            this.props.currentCharity
                          ) ||
                          this.props.disableGive
                        }
                      />
                    )}

                    {!isEmbeddedPost && !isParentPost && (
                      <ScheduleSection
                        colSize={colSize}
                        canEditPublishing={canEditable}
                        busyLoading={this.state.busyLoading}
                        scheduleDate={this.state.scheduleDate}
                        validateTime={this.state.validateTime}
                        enableTimeRestriction={this.props.enableTimeRestriction}
                        updateScheduleDate={this.updateScheduleDateHandler}
                        updateScheduleChecked={
                          this.updateScheduleCheckedHandler
                        }
                      />
                    )}
                  </Row>
                </Col>
              </Row>
              {!isParentPost && (
                <Row>
                  <Col md={12} sm={12} lg={12} xl={{ size: 8, offset: 2 }}>
                    <span className={s.requiredText}>* Required</span>
                    <hr style={{ clear: "right" }} />
                  </Col>
                </Row>
              )}
              {this.state.timeError && (
                <Row>
                  <Col
                    lg={12}
                    xl={{ size: 8, offset: 2 }}
                    className={s.dateError}
                  >
                    <span className={s.dateError}>
                      {this.state.timeErrorValue}
                    </span>
                  </Col>
                </Row>
              )}
              <Row>
                <Col
                  lg={12}
                  xl={{ size: 8, offset: 2 }}
                  className={s.toolbarCol}
                >
                  <div className={s.toolbarBar}>
                    <div
                      className={
                        isCurrentUserCollaborator(this.props.currentCharity)
                          ? `${s.toolbarCancelWrap} ${s.toolbarCancelWrapDivided}`
                          : s.toolbarCancelWrap
                      }
                    >
                      <Button
                        id={"cancelBackButton"}
                        onClick={() => this.props.navigate("/viewsparks")}
                        className={s.toolbarCancel}
                        color="link"
                        disabled={this.state.busyLoading !== null}
                      >
                        {isCurrentUserCollaborator(this.props.currentCharity)
                          ? "Cancel"
                          : "Back"}
                      </Button>
                    </div>
                    {isCurrentUserCollaborator(this.props.currentCharity) && (
                      <div className={s.toolbarActionGroup}>
                        {(!currentPost ||
                          currentPost.post.status !== "delivered") && (
                          <Button
                            id="saveDraftButton"
                            color="secondary"
                            outline
                            className={s.toolbarSecondary}
                            disabled={this.disableToDraft()}
                            onClick={() => this.createEditPost(true)}
                          >
                            {this.showSpinner("draft") ? (
                              <i className="fa fa-spinner fa-spin" />
                            ) : (
                              "Save Draft"
                            )}
                          </Button>
                        )}
                        <Button
                          id="publishButton"
                          color="primary"
                          className={s.toolbarPrimary}
                          disabled={this.disableToPublish()}
                          onClick={() => this.createEditPost(false)}
                        >
                          {this.showSpinner("publish") ? (
                            <i className="fa fa-spinner fa-spin" />
                          ) : currentPost?.post.status === "delivered" ? (
                            "Save"
                          ) : (
                            "Publish"
                          )}
                        </Button>
                        {!this.state.isMobileToolbar &&
                          this.shouldShowExtrasMenu() &&
                          this.renderExtrasDropdown("up")}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Fragment>
          )}
          {this.props.params.postId && !this.state.postDataLoaded && (
            <div className="d-flex full-width justify-content-center m-t-200 m-b-300">
              <ScaleLoader color={"#1f65b1"} loading />
            </div>
          )}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  const routeParams = props.params ?? {};
  const { firebase, user } = state;
  const charityId = user?.currentCharity?.id;
  const charityData = charityId ? firebase?.data?.[charityId] : undefined;
  const postsNodeName = routeParams.postType
    ? nodeForPostType(routeParams.postType)
    : null;
  const postsNode =
    postsNodeName && charityData ? charityData[postsNodeName] : undefined;

  const previousPost =
    routeParams.postId &&
    charityData &&
    isLoaded(charityData) &&
    postsNode &&
    isLoaded(postsNode) &&
    isLoaded(postsNode[routeParams.postId])
      ? postsNode[routeParams.postId]
      : null;

  const config = charityId ? `data.${charityId}.config` : "";

  const enableInformativePost = get(
    firebase,
    `${config}.enableInformativePost`
  );
  const defaultInformativePost = get(
    firebase,
    `${config}.defaultInformativePost`
  );
  const disableGive = get(firebase, `${config}.disableGive`, false);
  const enableMotivationCode = get(
    firebase,
    `${config}.enableMotivationCode`,
    false
  );
  const enableOnlySmsPost = get(firebase, `${config}.enableOnlySmsPost`, false);
  const enableTimeRestriction = get(
    firebase,
    `${config}.enableTimeRestriction`,
    false
  );

  const enableEmbeddedPost = get(
    firebase,
    `${config}.enableEmbeddedPost`,
    false
  );

  const enableParentPost = get(firebase, `${config}.enableSubCharities`, false);

  const selectedSubCharities =
    charityId && postsNodeName && routeParams.postId
      ? get(
          firebase,
          `data.${charityId}.${postsNodeName}.${routeParams.postId}.subCharities`
        )
      : undefined;

  const enableSalutationMessage = get(
    firebase,
    `${config}.enableSalutationMessage`,
    false
  );

  const enableUseCharityLogo = get(
    firebase,
    `${config}.notificationConfig.enableUseCharityLogo`,
    true
  );

  const defaultMessageTypeRaw = get(
    firebase,
    `${config}.defaultMessageType`,
    "onlyMms"
  );

  const showMmsVideoImage = get(firebase, `${config}.showMmsVideoImage`, true);

  const smsPostNotifications =
    !charityId ||
    get(firebase, `data.${charityId}.config.smsPostNotifications`) !== false;
  return {
    currentPost: !previousPost
      ? null
      : {
          post: previousPost,
          type: routeParams.postType,
        },
    pendingTwin:
      charityId && routeParams.postId
        ? get(
            firebase,
            `data.${charityId}.pendingPosts.${routeParams.postId}`
          ) || null
        : null,
    userId: firebase?.auth?.uid,
    enableInformativePost,
    enableOnlySmsPost,
    enableMotivationCode,
    enableTimeRestriction,
    enableEmbeddedPost,
    enableParentPost,
    subCharities: selectedSubCharities,
    enableSalutationMessage,
    enableUseCharityLogo,
    defaultMessageType:
      defaultMessageTypeRaw === "onlySms" ? "onlySms" : "onlyMms",
    showMmsVideoImage,
    smsPostNotifications: smsPostNotifications,
    defaultInformativePost: defaultInformativePost,
    disableGive: disableGive,
    firebaseSegments: charityId
      ? get(firebase, `data.${charityId}.segments`, [])
      : [],
    firebaseSelectedSubCharities: charityId
      ? get(
          firebase,
          `data.${charityId}.${postsNodeName}.${routeParams.postId}.subCharities`,
          []
        )
      : [],
    firebaseSubCharities: get(firebase, `${config}.subCharities`, []),
    defaultSendingEmail: get(
      firebase,
      `data.${charityId}.internal.emails.defaultEmail`,
      null
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
});

const PostDetailWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  firebaseConnect((props, store) => {
    const result =
      store.getState().user.currentCharity.id !== ""
        ? [
            `${store.getState().user.currentCharity.id}/config`,
            `${store.getState().user.currentCharity.id}/internal/emails`,
            `${store.getState().user.currentCharity.id}/segments`,
          ]
        : [];
    if (
      props.params?.postType &&
      props.params?.postId &&
      store.getState().user.currentCharity.id !== ""
    ) {
      const node = nodeForPostType(props.params.postType);
      const charityId = store.getState().user.currentCharity.id;
      result.push(`${charityId}/${node}/${props.params.postId}`);
      if (node === "publishedPosts") {
        result.push(`${charityId}/pendingPosts/${props.params.postId}`);
      }
    }
    return result;
  })(withStyles(s, confirmCss)(PostDetail))
);

export default serviceCaller(
  withLoginRedirect(withModals(withRouter(PostDetailWithRedux)))
);
